import axiosClient from 'utils/axiosClient';
import { CommonResponse } from 'models';
import { DataLoadForm } from 'features/AssetScreen/models/DataLoadForm';
import { ManufacturerPayload } from 'features/AssetScreen/models/Manufacturer';
import { AssetModelPayload } from 'features/AssetScreen/models/AssetModel';
import { DepartmentShort } from 'features/AssetScreen/models/Department';
import { EmployeeShort } from 'features/AssetScreen/models/Employee';
import { StoragePlaceShort } from 'features/AssetScreen/models/StoragePlace';
import { AssetForm, Asset } from 'features/AssetScreen/models/Asset';
import { Company } from 'features/AssetScreen/models/Company';
const assetAddService = {
  getPreDataFormAdd(): Promise<DataLoadForm> {
    const url = 'assets-data-load-form';
    return axiosClient.get(url);
  },

  fetchManufactures(params: string): Promise<ManufacturerPayload> {
    const url = 'assets-get-manufactures?' + params;
    return axiosClient.get(url);
  },

  fetchModels(params: string): Promise<AssetModelPayload> {
    const url = 'assets-get-models?' + params;
    return axiosClient.get(url);
  },

  fetchDepartment(params: string): Promise<CommonResponse<DepartmentShort>> {
    const url = 'assets-get-department?' + params;
    return axiosClient.get(url);
  },

  async fetchEmployee(params: string): Promise<CommonResponse<EmployeeShort>> {
    const url = 'assets-get-employee?' + params;
    return axiosClient.get(url);
  },
  async fetchStoragePlace(params: string): Promise<CommonResponse<StoragePlaceShort>> {
    const url = 'assets-get-storage-place?' + params;
    return axiosClient.get(url);
  },
  async saveAsset(body: AssetForm): Promise<ManufacturerPayload> {
    const url = 'asset';
    return axiosClient.post(url, body);
  },
  async checkAssetCode(params: string): Promise<CommonResponse<Asset>> {
    const url = 'assets-get-with-code?' + params;
    return axiosClient.get(url);
  },
  fetchCompanies(params: string): Promise<CommonResponse<Company[]>> {
    const url = 'get-companies?' + params;
    return axiosClient.get(url);
  },
};

export default assetAddService;
